var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWhat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.007,
    height: 49,
    viewBox: "0 0 48.007 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment",
    transform: "translate(-0.111 0.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6824",
    "data-name": "Group 6824"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1211",
    "data-name": "Ellipse 1211",
    cx: 24,
    cy: 24.5,
    rx: 24,
    ry: 24.5,
    transform: "translate(0.111 -0.446)",
    fill: "#53b3cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15056",
    "data-name": "Path 15056",
    d: "M168.166,85.186c0-.967-6.336-7.008-9.34-9.648l-9.975.543-4.741-3.839-4.263.531L126.366,83.594l11.471,25.368a24.167,24.167,0,0,0,30.329-23.776Z",
    transform: "translate(-120.048 -61.29)",
    fill: "#3f9eb5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6794",
    "data-name": "Group 6794",
    transform: "translate(4.137 4.877)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    "data-name": "Rectangle 1763",
    width: 33.33,
    height: 32.497,
    rx: 5,
    transform: "translate(4.161 5.457) rotate(-5)",
    fill: "#2f8495"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15057",
    "data-name": "Path 15057",
    d: "M4.166,0h25A4.166,4.166,0,0,1,33.33,4.166V28.331A4.166,4.166,0,0,1,29.164,32.5h-25A4.166,4.166,0,0,1,0,28.331V4.166A4.166,4.166,0,0,1,4.166,0Z",
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 0, 6.93)",
    fill: "#51aabc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15058",
    "data-name": "Path 15058",
    d: "M9.616-26.3q2.01.72,2.01,1.92a5.813,5.813,0,0,1-.36,1.47L5.506-6.266a3.078,3.078,0,0,1-.21.51,2.868,2.868,0,0,1-.795.795,2.44,2.44,0,0,1-1.53.495,2.44,2.44,0,0,1-1.53-.495,2.656,2.656,0,0,1-.855-.975l-3.51-10.349q-3.33,9.839-3.39,10.019a2.594,2.594,0,0,1-.27.51,3.51,3.51,0,0,1-.48.6,2.251,2.251,0,0,1-1.65.69,2.6,2.6,0,0,1-1.575-.45,2.5,2.5,0,0,1-.825-.9l-.21-.45-5.789-16.649a5.232,5.232,0,0,1-.33-1.47q0-1.2,2.01-1.89a4.882,4.882,0,0,1,1.575-.3,1.289,1.289,0,0,1,1.08.48,4.609,4.609,0,0,1,.675,1.47l3.3,10.019,3.27-9.869A2.725,2.725,0,0,1-4-26.214a3.135,3.135,0,0,1,1.245-.21,2.328,2.328,0,0,1,1.425.495,2.348,2.348,0,0,1,.84.975l3.45,10.409,3.3-10.079q.24-.69.39-1.02a1.794,1.794,0,0,1,.555-.645,1.587,1.587,0,0,1,1-.315A4.156,4.156,0,0,1,9.616-26.3Z",
    transform: "translate(21.754 35.877)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhat);
export default __webpack_public_path__ + "static/media/icon-what.04d46650.svg";
export { ForwardRef as ReactComponent };